import { FC, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";
import { IAPIState, IStatus } from "shared/types";
import {
  dataMetaSelector,
  venueSelectorCreator,
  unpublishVenue,
  dispatchGetVenueAction,
} from "Venues/state";
import { VENUE_ACTIONS } from "Venues/types";
import { useClearActionMetaOnUnMount } from "Venues/utils";
import { addTemporaryToast } from "shared/components/Toast";

export interface UnpublishModalProps {
  venueId: string;
  handleClose: () => void;
}

export const UnpublishModal: FC<UnpublishModalProps> = ({ venueId, handleClose }) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(VENUE_ACTIONS.unpublishVenue));

  const venueIdSelector = useMemo(() => venueSelectorCreator(venueId), [venueId]);
  const venue = useSelector(venueIdSelector);

  useClearActionMetaOnUnMount(VENUE_ACTIONS.unpublishVenue);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          message: copy.unpublishVenue.success,
          status: IStatus.success,
        })
      );
      // refetch venue to update permissions
      dispatchGetVenueAction(dispatch, venueId);
      handleClose();
    }
  }, [apiMeta, venueId, dispatch, handleClose]);

  const handleUnpublish = () => {
    dispatch(unpublishVenue(venueId));
  };

  return (
    <DeleteModal
      handleClose={handleClose}
      handleDelete={handleUnpublish}
      apiMeta={apiMeta}
      name={venue?.title || ""}
      customButtonCopy={copy.unpublishVenue.button}
      customDeleteCopy={copy.unpublishVenue.message}
    />
  );
};
